import { useContext, useEffect, useState } from "react";
import { Assets } from "../../../../../assets";
// import { GoBack } from "../../../../common/components/GoBack/GoBack";
import SalesOperationsCards from "../components/SalesOperationsCards";
// import { FaPlusSquare } from "react-icons/fa";
import style from "./style.module.scss";
import { Avatar, Divider, List, Progress } from "antd";
// import StaffCards from "./components/StaffCards";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router";
import { CommercialOperation, DetailService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import { FormatDate } from "../../../../../utilities/formatDate";
import { TitleHeader } from "../../../../../common/components/TitleHeader/TitleHeader";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { Container } from "../../../../../common/components/container/Container";
import { CustomCalendar } from "../../../../../common/components/Calendar/CustomCalendar";
import { EventContentArg } from "@fullcalendar/core";
import { MdOutlineEventBusy } from "react-icons/md";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { RiTeamFill } from "react-icons/ri";
import { CiSettings } from "react-icons/ci";

export const OperationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialValue, setInitialValue] = useState<any>();
  const [isLoadingOperation, setIsLoadingOperation] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const [selectedTeam, setSelectedTeam] = useState<any>({});
  const [operationTypeValue, setOperationTypeValue] = useState<string>("");

  const percent = initialValue?.dataKpi?.global?.percentage;

  useEffect(() => {
    id && fetchTeamOrder(+id);
  }, [id]);

  const fetchTeamOrder = async (id: number, params?: any) => {
    try {
      setIsLoadingOperation(true);
      const res = await CommercialOperation.getOneOperation(id, params);

      if (res?.status === HttpStatusCode.Ok) {
        // setTitle(res?.data?.reference);

        setInitialValue(
          formatData({
            ...res?.data,
          })
        );
        setOperationTypeValue(res?.data?.operationType?.name);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingOperation(false);
    }
  };
  const formatData = (data: any) => {
    const formattedData = {
      ...data,
      holdsValueLength: data?.holds?.length,
      receiptRequestAt: data?.receiptRequestAt
        ? FormatDate.dayjsFormat(data?.receiptRequestAt)
        : null,
      estimatedArrivalAt: data?.estimatedArrivalAt
        ? FormatDate.dayjsFormat(data?.estimatedArrivalAt)
        : null,
      startAt: data?.startAt ? FormatDate.dayjsFormat(data?.startAt) : null,
      endAt: data?.endAt ? FormatDate.dayjsFormat(data?.endAt) : null,
      teamOrderFile: data?.teamOrderFile
        ? {
            label: data?.teamOrderFile?.basename,
            value: data?.teamOrderFile?.["@id"],
          }
        : null,
      arrivalNoticeFile: data?.arrivalNoticeFile
        ? {
            label: data?.arrivalNoticeFile?.basename,
            value: data?.arrivalNoticeFile?.["@id"],
          }
        : null,
      embarkationPlanFile: data?.embarkationPlanFile
        ? {
            label: data?.embarkationPlanFile?.basename,
            value: data?.embarkationPlanFile?.["@id"],
          }
        : null,
      debarkationPlanFile: data?.debarkationPlanFile
        ? {
            label: data?.debarkationPlanFile?.basename,
            value: data?.debarkationPlanFile?.["@id"],
          }
        : null,
      customer: data?.customer
        ? {
            label: data?.customer?.name,
            value: data?.customer?.[`@id`],
          }
        : null,
      customerCategory: data?.customer
        ? {
            label: data?.customer?.customerCategory?.name,
            value: data?.customer?.customerCategory?.[`@id`],
          }
        : null,
      operationType: data?.operationType
        ? {
            label: data?.operationType?.name,
            value: data?.operationType?.["@id"],
          }
        : null,
      operationShifting: data?.operationShifting
        ? {
            label: data?.operationShifting?.name,
            value: data?.operationShifting?.["@id"],
          }
        : null,
      teamsDockside: data?.teamsDockside?.map((item: any) => ({
        ...item,
        teamShiftStart: FormatDate.dayjsTimeFormat(
          item?.teamShiftStart ?? "06:00"
        ),
        teamShiftEnd: FormatDate.dayjsTimeFormat(item?.teamShiftEnd ?? "18:00"),
        ...(item?.assignmentLocation
          ? {
              assignmentLocation: {
                label: item?.assignmentLocation?.name,
                value: item?.assignmentLocation?.["@id"],
              },
            }
          : {}),
      })),
      teamsOnBoard: data?.teamsOnBoard?.map((item: any) => ({
        ...item,
        teamShiftStart: FormatDate.dayjsTimeFormat(item?.teamShiftStart),
        teamShiftEnd: FormatDate.dayjsTimeFormat(item?.teamShiftEnd),
      })),
      teamsStorage: data?.teamsStorage?.map((item: any) => ({
        ...item,
        teamShiftStart: FormatDate.dayjsTimeFormat(item?.teamShiftStart),
        teamShiftEnd: FormatDate.dayjsTimeFormat(item?.teamShiftEnd),
      })),
    };

    return formattedData;
  };

  const formatListData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
      teamId: item?.id,
      time: item?.teamShift
        ? `${item?.teamShift?.start} - ${item?.teamShift?.end}`
        : "",
      start: item?.createdAt
        ? dayjs(item?.createdAt, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
        : null,
    }));
  };

  const onOpenDrawerHandler = () => {
    setIsOpenDrawer((prev: boolean) => {
      return !prev;
    });
  };

  const handleClickOnTeam = async (teamId: number) => {
    try {
      setIsLoading(true);
      const res = await DetailService.getStaffs(teamId);
      if (res?.status === HttpStatusCode.Ok) {
        setSelectedTeam(res?.data);
        onOpenDrawerHandler();
      }
    } catch (_: any) {
    } finally {
      setIsLoading(false);
    }
  };

  const onRedirect = () => {
    //const movement = initialValue?.debarkationMovement?.['@id'].split('/').pop() || initialValue?.embarkationMovement?.['@id'].split('/').pop();
    navigate(`../operation/${id}`)
  }

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      {isLoadingOperation ? (
        <Loader isLoading={isLoadingOperation} />
      ) : (
        <div className="">
          <TitleHeader
            title=""
            isSHowBack
            subTitle={`${initialValue?.reference ?? ""}`}
          />
          <div className={style.buttonWrapper}>
            <div className={style.buttonLike} onClick={onRedirect}>
              <CiSettings size={22} />
              Paramétrage
            </div>
          </div>          
          <Container>
            <div className={style.details}>
              <div className={style.details__container}>
                {/* Wrapper containing left + middle containers and the calendar */}
                <div className={style.details__left_wrapper}>
                  {/* Top group with left et middle containers*/}
                  <div className={style.details__top_group}>
                    {/* Left container */}
                    <div className={style.details__item}>
                      <SalesOperationsCards
                        className={style.details__card_container}
                      >
                        <div className="d-flex gap-4">
                          <div className={style.details__image_wrapper}>
                            <img
                              src={Assets.images.ships}
                              className={style.image}
                            />
                          </div>
                          <div className={style.details__card_title_wrapper}>
                            <span className={style.details__card_title}>
                              {initialValue?.reference}
                            </span>
                            <span
                              className={style.details__card_text}
                            >{`ETA  ${dayjs(
                              initialValue?.estimatedArrivalAt,
                              "DD/MM/YYYY"
                            )?.format("DD/MM/YYYY")}`}</span>
                            <span className={style.details__card_text}>
                            {/* Provenance : {initialValue?.origin ? (
                              initialValue.origin
                            ) : (
                              <i style={{ fontStyle: 'italic', opacity: 0.8 }}>Non renseignée</i>
                            )} */}
                          </span>
                            <span className={style.details__card_text}>
                              {/* {(initialValue?.operationType?.id === "EMBARKATION_DEBARKATION")
                                ? "Débarquement/Embarquement"
                                : (initialValue?.operationType?.id === "DEBARKATION")
                                ? "Débarquement"
                                : "Embarquement"} */}
                                {operationTypeValue}
                            </span>
                            <span
                              className={style.details__card_text}
                            >
                              Marchandise : {initialValue?.loadsTxt ? (
                              initialValue.loadsTxt
                            ) : (
                              <i style={{ fontStyle: 'italic', opacity: 0.8 }}>En attente de manifeste.</i>
                            )}
                            </span>
                          </div>
                        </div>
                        <button
                          className={style.details__footer_button}
                          onClick={() =>
                            navigate(
                              `/app/operations/sales-operations/operation/${id}/operation-folders`
                            )
                          }
                        >
                          <span>
                            <img src={Assets.images.file} /> Documents liés
                          </span>
                        </button>
                      </SalesOperationsCards>
                    </div>
                  </div>

                  {/* Place for the calendar */}
                  <div className={style.details__calendar}></div>
                </div>

                {/* Right container */}
                <div className={style.details__right_wrapper}>
                  {/* <SalesOperationsCards pointer title="Planification Débarquement Ciment Big Bag" icon={<img src={Assets.images.calendar} />} /> */}
                  <SalesOperationsCards
                    className="mt-1"
                    title="Avancement global"
                    icon={<img src={Assets.images.diagram} />}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        marginTop: "25px",
                        marginBottom: "25px",
                      }}
                    >
                      <Progress size={100} type="circle" percent={percent} />
                    </div>
                  </SalesOperationsCards>
                </div>
              </div>
            </div>

            <div className="mx-2 p-4 detail-perso">
              <CustomCalendar
                onClick={(e: any) => {
                  console.log(e);
                }}
                events={formatListData(initialValue?.allTeamsArray)}
                renderContent={(e: EventContentArg) => (
                  <div
                    className={"calendar__event"}
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleClickOnTeam(e?.event?.extendedProps?.teamId);
                    }}
                  >
                    <div className={"calendar__event_icon"}>
                      <MdOutlineEventBusy size={20} />
                    </div>
                    <div className="d-flex flex-column ">
                      <span className={"calendar__event_title"}>
                        {e?.event?.extendedProps?.name}
                      </span>
                      <span className={"calendar__event_title"}>
                        {e?.event?.extendedProps?.time}
                      </span>
                    </div>
                  </div>
                )}
              />
            </div>
          </Container>

          {isOpenDrawer ? (
            <CustomDrawer
              isOpen={isOpenDrawer}
              onClose={onOpenDrawerHandler}
              width={600}
              title={`${selectedTeam?.name}`}
            >
              <div
                className="d-flex gap-2 align-items-center justify-content-center pb-2"
                style={{
                  borderBottom: "dashed 1px #EEEEEE",
                  color: "#58A0C8",
                }}
              >
                <RiTeamFill
                  style={{
                    fontSize: "25px",
                  }}
                />
                <div className="">
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    {selectedTeam?.teamType?.name}{" "}
                  </span>
                </div>
              </div>
              <div className="d-flex gap-4 flex-column">
                {selectedTeam?.allStaffs?.map((staffPost: any) => (
                  <div>
                    <Divider orientation="left" plain>
                      <span> {staffPost?.post} </span>
                    </Divider>

                    <List
                      itemLayout="horizontal"
                      dataSource={staffPost?.names}
                      renderItem={(item: string, index) => (
                        <List.Item key={index}>
                          <List.Item.Meta
                            avatar={
                              <Avatar style={{ backgroundColor: "#58A0C8" }}>
                                {[...item?.split("")][0]}
                              </Avatar>
                            }
                            description={item}
                          />
                        </List.Item>
                      )}
                    />
                  </div>
                ))}
              </div>
            </CustomDrawer>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};
